import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const it: Translations = {
  common: {
    appName: appName,
    loading: 'Caricamento...',
    save: 'Salva',
    cancel: 'Annulla',
    confirm: 'Conferma',
    delete: 'Elimina',
    edit: 'Modifica',
    back: 'Indietro',
    search: 'Cerca',
    noResults: 'Nessun risultato trovato',
    error: 'Si è verificato un errore',
    success: 'Operazione riuscita',
  },
  header: {
    searchPlaceholder: 'Cerca coser, hotgirl, ao dai, modelle...',
    searchPlaceholderMobile: 'Cerca...',
    home: 'Home',
    hotgirl: 'Hotgirl',
    coser: 'Coser',
    model: 'Modella',
    upload: 'Carica',
    notifications: 'Notifiche',
    login: 'Accedi',
    register: 'Registrati',
  },
  footer: {
    tagline: `La migliore piattaforma per condividere foto di Coser, Hotgirl e Modelle su ${appName}.`,
    copyright: `© {year} ${appName}. Tutti i diritti riservati.`,
    sections: {
      explore: 'Esplora',
      account: 'Account',
      support: 'Supporto',
    },
    links: {
      home: 'Home',
      hotgirl: 'Hotgirl',
      coser: 'Coser',
      model: 'Modella',
      aoDai: 'Ao Dai',
      login: 'Accedi',
      register: 'Registrati',
      upload: 'Carica Foto',
      dashboard: 'Dashboard',
      terms: 'Termini di Servizio',
      privacy: 'Informativa sulla Privacy',
      report: 'Segnala Violazione',
      contact: 'Contattaci',
    },
  },
  collections: {
    title: 'Collezioni',
    createAlbum: 'Crea Album',
    saved: 'Salvati',
    noSaved: 'Nessuna foto salvata',
    noSavedHint: 'Esplora le foto ora →',
    removedSave: 'Rimosso dai salvati',
    createModalTitle: 'Crea nuovo album',
    albumNamePlaceholder: 'Nome album...',
    cancel: 'Annulla',
    create: 'Crea',
    albumCreated: 'Album creato',
  },
  home: {
    title: 'Scopri la',
    titleHighlight: 'bellezza',
    titleSuffix: 'della vita',
    subtitle: 'Migliaia di foto di Coser, Hotgirl e Modelle aggiornate ogni giorno',
    sortNewest: 'Più Recenti',
    sortTrending: 'Trending',
    sortPopular: 'Popolari',
    allCategories: 'Tutti',
    noMorePosts: 'Hai visto tutte le foto',
  },
  auth: {
    login: {
      title: 'Accedi per continuare',
      continueWithGoogle: 'Continua con Google',
      orLoginWithEmail: 'o accedi con email',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Password dimenticata?',
      submitButton: 'Accedi',
      loading: 'Accesso in corso...',
      noAccount: 'Non hai un account?',
      registerLink: 'Registrati ora',
      errorCredentials: 'Email o password errati',
      successLogin: 'Accesso effettuato!',
    },
    register: {
      title: 'Crea un account gratuito',
      displayName: 'Nome Visualizzato',
      displayNamePlaceholder: 'Mario Rossi',
      email: 'Email',
      password: 'Password',
      passwordPlaceholder: 'Almeno 8 caratteri',
      confirmPassword: 'Conferma Password',
      submitButton: 'Registrati',
      loading: 'Creazione account...',
      hasAccount: 'Hai già un account?',
      loginLink: 'Accedi',
      errorPasswordMismatch: 'Le password non coincidono',
      errorPasswordLength: 'La password deve avere almeno 8 caratteri',
      errorGeneric: 'Registrazione fallita',
      successRegister: 'Account creato con successo!',
      emailTaken: 'Email già in uso',
      serverError: 'Errore del server, riprova più tardi',
    },
    forgotPassword: {
      title: 'Password dimenticata',
      subtitle: 'Inserisci la tua email e ti invieremo un link di reset',
      email: 'Email',
      submitButton: 'Invia Link di Reset',
      backToLogin: 'Torna al login',
      sending: 'Invio in corso...',
      emailSent: 'Email inviata!',
      checkEmail: 'Controlla la casella di posta di {email} per il link di reset della password.',
      instructions: 'Inserisci la tua email e ti invieremo un link per reimpostare la password.',
    },
  },
  userMenu: {
    dashboard: 'Dashboard',
    collections: 'Collezioni',
    settings: 'Impostazioni',
    logout: 'Esci',
  },
  settings: {
    title: 'Impostazioni Account',
    profile: {
      nav: 'Profilo',
      title: 'Informazioni Profilo',
      displayName: 'Nome Visualizzato',
      username: 'Nome Utente',
      website: 'Sito Web',
      bio: 'Bio',
      bioPlaceholder: 'Presentati...',
      changeAvatar: 'Cambia Avatar',
      avatarHint: 'JPG, PNG, WebP max 5MB',
      saveButton: 'Salva Modifiche',
      saving: 'Salvataggio...',
      savedSuccess: 'Modifiche salvate',
    },
    password: {
      nav: 'Password',
      title: 'Cambia Password',
      fields: {
        currentPassword: 'Password Attuale',
        newPassword: 'Nuova Password',
        confirm: 'Conferma Nuova Password',
      },
      errors: {
        confirm: 'Le nuove password non coincidono',
        minLength: 'La password deve avere almeno 8 caratteri',
      },
      success: 'Password modificata con successo!',
      saving: 'Salvataggio...',
      submit: 'Cambia Password',
    },
    notifications: {
      nav: 'Notifiche',
      title: 'Impostazioni Notifiche',
      options: {
        likes: 'Quando qualcuno mette mi piace alla tua foto',
        comments: 'Quando qualcuno commenta',
        replies: 'Quando qualcuno risponde al tuo commento',
        follows: 'Quando qualcuno ti segue',
        approved: 'Quando il post viene approvato',
        email_digest: 'Riepilogo email settimanale',
        marketing: 'Notifiche promozionali e di eventi',
      },
      saveSuccess: 'Impostazioni notifiche salvate',
      saving: 'Salvataggio...',
      saveButton: 'Salva Impostazioni',
    },
    security: {
      nav: 'Sicurezza',
      twoFactorAuth: 'Autenticazione a Due Fattori (2FA)',
      twoFactorAuthHint: "Aumenta la sicurezza con un codice di verifica dall'app",
      comingSoon: 'Prossimamente',
      activeSessions: 'Sessioni Attive',
      currentBrowser: 'Browser Corrente',
      lastLogin: 'Ultimo Accesso',
      active: 'Attivo',
      dangerZone: 'Zona Pericolosa',
      deleteAccountHint: 'Eliminare il tuo account rimuoverà permanentemente tutti i tuoi dati.',
      deleteAccount: 'Elimina Account',
    },
  },
  post: {
    likes: '{count} mi piace',
    views: '{count} visualizzazioni',
    shares: '{count} condivisioni',
    comments: '{count} commenti',
    save: 'Salva',
    saved: 'Salvato',
    share: 'Condividi',
    linkCopied: 'Link copiato!',
    follow: 'Segui',
    following: 'Seguito',
    relatedPosts: 'Post Correlati',
    commentPlaceholder: 'Scrivi un commento...',
    commentLoginPlaceholder: 'Accedi per commentare...',
    commentSubmit: 'Pubblica',
    commentSubmitting: 'Pubblicazione...',
    noComments: 'Ancora nessun commento. Sii il primo!',
    savedToCollection: 'Salvato nella collezione',
    removedFromCollection: 'Rimosso dalla collezione',
    description: 'Descrizione',
    profileView: 'Visualizza profilo',
  },
  notifications: {
    title: 'Notifiche',
    empty: 'Nessuna notifica',
    markAllRead: 'Segna tutto come letto',
    types: {
      like_post: 'ha messo mi piace alla tua foto',
      comment: 'ha commentato la tua foto',
      reply: 'ha risposto al tuo commento',
      follow: 'ti ha seguito',
      approve: 'il tuo post è stato approvato',
      reject: 'il tuo post è stato rifiutato',
      system: 'notifica di sistema',
    },
  },
  search: {
    title: 'Risultati per',
    result: 'Risultati',
    tryOtherKeywords: 'Prova altre parole chiave...',
    noResults: 'Nessun risultato per',
    placeholder: 'Cerca...',
    thisHashtag: 'foto con questo hashtag',
  },
  upload: {
    title: 'Carica Foto',
    dragDrop: 'Trascina e rilascia o clicca per selezionare',
    supportedFormats: 'Supporta JPG, PNG, WebP, GIF',
    submit: 'Pubblica',
    submitting: 'Pubblicazione...',
    titleField: 'Titolo',
    titlePlaceholder: 'Inserisci un titolo accattivante...',
    descriptionField: 'Descrizione',
    descriptionPlaceholder: 'Descrizione dettagliata del set fotografico...',
    hashtagsField: 'Hashtag',
    statusField: 'Stato',
    statusPublic: 'Pubblico',
    statusPrivate: 'Privato',
    statusDraft: 'Bozza',
    error: 'Errore nel caricamento',
    errorSelect: 'Seleziona almeno 1 foto',
    errorTitle: 'Inserisci un titolo',
    photos: 'foto',
    uploading: 'Caricamento...',
  },
  notFound: {
    title: 'Pagina non trovata',
    subtitle: 'La pagina che stai cercando non esiste.',
    backHome: 'Torna alla Home',
  },
  liked: {
    title: 'Post con Mi Piace',
    empty: 'Non hai ancora messo mi piace a nessun post.',
  },
  user: {
    unknown: 'Sconosciuto',
  },
  globalError: {
    title: 'Si è verificato un errore',
    subtitle: 'Ci scusiamo per il disagio. Riprova.',
    retry: 'Riprova',
  },
  username: {
    posts: 'Post',
    likes: 'Mi Piace',
    followers: 'Follower',
    following: 'Seguiti',
    editProfile: 'Modifica Profilo',
    message: 'Messaggio',
    noPosts: 'Ancora nessun post.',
    bio: 'Visualizza foto di ',
    notFound: 'Utente non trovato',
  },
  topic: {
    notFound: 'Argomento non trovato',
    viewTitle: 'Visualizza argomento ',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Ciao',
    stats: {
      posts: 'Post',
      views: 'Visualizzazioni',
      likes: 'Mi Piace',
      comments: 'Commenti',
    },
  },
  adsblock: {
    title: 'Stai usando AdBlock',
    description: 'Disabilita AdBlock per visualizzare immagini di alta qualità e aiutarci a mantenere il sito gratuito.',
    action: 'Ho disabilitato — Ricarica',
    cancel: 'Salta',
  },
  pwa: {
    title: `Installa ${appName} per un'esperienza migliore!`,
    iosSubtitle: `Premi Condividi → Aggiungi alla schermata Home`,
    androidSubtitle: `Ricevi notifiche sui nuovi set di foto non appena vengono rilasciati`,
    installButton: `Installa ${appName}`,
    disclaimer: `Installazione rapida, nessun app store richiesto.`,
  },
  autotrans: {
    title: 'Tradotto automaticamente',
    translated: 'Traduzione',
    origin: 'Contenuto originale',
  },
  subscription: {
    title: 'Iscriviti alle notifiche',
    description: 'Ricevi notifiche sui nuovi set di foto non appena vengono rilasciati.',
    subscribeButton: 'Iscriviti',
    unsubscribeButton: 'Disiscriviti',
    subscribed: 'Sei iscritto alle notifiche.',
    unsubscribed: 'Ti sei disiscritto dalle notifiche.',
    error: 'Si è verificato un errore durante l\'aggiornamento della tua iscrizione. Riprova.',
    success_tit: '🎉 Notifiche attivate!',
    denied_tit: 'Notifiche negate',
    error_tit: 'Si è verificato un errore',
    success_des: 'Riceverai notifiche quando nuovi contenuti saranno disponibili.',
    denied_des: 'Puoi riattivarle nelle impostazioni del tuo browser.',
    error_des: 'Si prega di riprovare più tardi.',
    skip: 'Salta',
    processing: 'Elaborazione...',
    noti: 'Abilita notifiche',
    rule: 'Mostra solo notifiche per nuovi contenuti.',
    notify_title: `Notifiche - ${appName}`,
    notify_body: "La nuova galleria è stata rilasciata. Controllala ora!",
  },
  contact: {
    title: 'Contattaci',
    subtitle: 'Ci piacerebbe sapere da te! Compila il modulo qui sotto e ti contatteremo il prima possibile.',
    name: 'Nome',
    email: 'Email',
    subject: 'Oggetto',
    message: 'Messaggio',
    submitButton: 'Invia Messaggio',
    sending: 'Invio...',
    successTitle: 'Messaggio Inviato!',
    successMessage: 'Grazie per averci contattato. Ti risponderemo a breve.',
    errorTitle: 'Si è verificato un errore',
    errorMessage: 'Si è verificato un errore durante l\'invio del messaggio. Riprova più tardi.',
    res_time_title: 'Tempo di risposta',
    res_time: 'Di solito rispondiamo entro 1-3 giorni lavorativi.',
    report_content: 'Segnala contenuto',
    report_content_hint: 'Per segnalare un post o un utente, utilizzare il pulsante di segnalazione direttamente sul contenuto o selezionare &ldquo;Segnala contenuto&rdquo; sopra.',
    value_default: 'Seleziona un argomento',
    value_general: 'Richiesta generale',
    value_report: 'Segnala contenuto',
    value_account: 'Problema con l\'account',
    value_business: 'Business / partnership',
    value_feedback: 'Feedback & suggestions',
    value_other: 'Altro'
  },
  language: {
    label: 'Lingua',
    en: 'English',
    vi: 'Tiếng Việt',
    zh: '中文',
    ja: '日本語',
    ko: '한국어',
    ar: 'العربية',
    fr: 'Français',
    es: 'Español',
    ru: 'Русский',
    hi: 'हिन्दी',
    id: 'Indonesia',
    de: 'Deutsch',
    pt: 'Português',
    it: 'Italiano',
  },
} as const;

export default it;